<template>
    <div>
        <app-no-data-message v-if="!tableData.length" />
        <app-data-table
            :fields="fields"
            :items="tableData"
            @sort="onSort"
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        >
            <template slot="description" slot-scope="{ item }">
                {{ item.description | elipsis(80) }}
            </template>

            <template slot="created_at" slot-scope="{ item }">
                {{ item.created_at | datetime }}
            </template>

            <template slot="due_date" slot-scope="{ item }">
                {{ item.due_date | datetime }}
            </template>

            <template v-slot:assigneeCreatedAt="{ item }">
                <span v-if="!!item.lastPetitionAssignment">
                    {{ item.lastPetitionAssignment.created_at | datetime }}
                </span>
            </template>

            <template v-slot:assigneeName="{ item }">
                <span
                    v-if="!!item.lastPetitionAssignment"
                    :class="{
                        'text-danger': !!item.lastPetitionAssignment.user
                            .deleted_at,
                    }"
                >
                    {{ item.lastPetitionAssignment.user.name }}
                </span>
            </template>

            <template slot="files" slot-scope="{ item }">
                <div v-if="item.files.length" v-for="(file, i) in item.files">
                    <a :href="'/download/' + file.id" target="_blank"
                        >{{ i + 1 }} - {{ file.name }}</a
                    >
                </div>
            </template>

            <template slot="actions" slot-scope="{ item }">
                <b-button
                    size="sm"
                    variant="primary"
                    title="Ver Comentarios"
                    :disabled="!item.comments.length"
                    @click="seeCommentsByPetition(item)"
                    ><i class="fa fa-comments"></i
                ></b-button>
                <b-button
                    variant="primary"
                    size="sm"
                    title="Ver PQR"
                    @click="seeMore(item)"
                    ><i class="fa fa-search-plus" aria-hidden="true"></i
                ></b-button>
                <b-button
                    variant="primary"
                    size="sm"
                    title="Reasignar"
                    @click="startReAssignUserToPetition(item)"
                    ><i class="fa fa-retweet" aria-hidden="true"></i
                ></b-button>
                <b-button
                    variant="primary"
                    size="sm"
                    title="Agregar Comentario"
                    @click="startAddComment(item)"
                    ><i class="fa fa-pencil-square-o" aria-hidden="true"></i
                ></b-button>
            </template>
        </app-data-table>
    </div>
</template>
<script>
export default {
    data() {
        return {
            fields: [
                {
                    key: 'petition_type.name',
                    label: 'Tipo',
                },
                {
                    key: 'client.name',
                    label: 'Cliente',
                },
                {
                    key: 'user.name',
                    label: 'Usuario creador',
                },
                {
                    key: 'description',
                    label: 'Descripción',
                },
                {
                    key: 'created_at',
                    label: 'Fecha creación',
                },
                {
                    key: 'due_date',
                    label: 'Fecha vencimiento',
                },
                {
                    key: 'assigneeCreatedAt',
                    label: 'Fecha asignación responsable',
                },
                {
                    key: 'assigneeName',
                    label: 'Usuario asignado',
                },

                {
                    key: 'files',
                    label: 'Archivos',
                    sortable: false,
                },
                {
                    key: 'actions',
                    label: 'Acciones',
                },
            ],
        }
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        seeCommentsByPetition: {
            type: Function,
            required: true,
        },
        seeMore: {
            type: Function,
            required: true,
        },
        onChangePage: {
            type: Function,
            required: true,
        },
        startReAssignUserToPetition: {
            type: Function,
            required: true,
        },
        startAddComment: {
            type: Function,
            required: true,
        },
    },
    computed: {
        tableData() {
            if (!this.data || !this.data.data || !this.data.data.length)
                return []

            return this.data.data.map(item => {
                let today = moment()
                let dueDate = moment(item.due_date)
                const classes = today.isSame(dueDate, 'day')
                    ? 'today'
                    : today.isAfter(dueDate)
                    ? 'overdue'
                    : ''
                const _rowDetails = true
                return { ...item, classes, _rowDetails }
            })
        },
    },
    methods: {
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
    },
}
</script>
